import { render, staticRenderFns } from "./add-to-power-dialer.vue?vue&type=template&id=64916e6c"
import script from "./add-to-power-dialer.vue?vue&type=script&lang=js"
export * from "./add-to-power-dialer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports